/**
 * Display helpers for `ai_paused_reason` (SPEC-2288). Pure module — no
 * axios/client imports — so it stays unit-testable under node:test.
 */

/**
 * Strips the leading classifier the backend prepends to `ai_paused_reason`
 * (`manual: …`, `crm_suppression: …`, `CINC: …`) so the UI can render the
 * raw reason the user supplied.
 */
const PAUSE_REASON_PREFIX = /^(manual|crm_suppression|CINC):\s*/i;
export const stripManualPausePrefix = (reason?: string | null): string =>
  reason?.replace(PAUSE_REASON_PREFIX, '').trim() ?? '';

/**
 * Renders `ai_paused_reason` as agent-readable text (SPEC-2288). Machine
 * classifiers written by the sync layer (`crm_tag: …` for a speculo_no_ai
 * tag applied in the CRM, `stage_blocked: …` for the stage allowlist) get a
 * plain-English phrasing; everything else falls back to the prefix strip.
 */
const TAG_PAUSE_REASON = /^crm_tag:\s*(.+)$/i;
const STAGE_PAUSE_REASON = /^stage_blocked:\s*(.+)$/i;
export const formatPauseReason = (reason?: string | null): string => {
  const raw = reason?.trim() ?? '';
  const tagMatch = raw.match(TAG_PAUSE_REASON);
  if (tagMatch) return `"${tagMatch[1].trim()}" tag applied in CRM`;
  const stageMatch = raw.match(STAGE_PAUSE_REASON);
  if (stageMatch) return `Moved to disallowed stage: ${stageMatch[1].trim()}`;
  return stripManualPausePrefix(raw);
};
